const updateConfigs = (state, payload) => {
  state.configs = payload
}

export default {
  updateConfigs
}
